/*
 * Service loadCustomerInfo, replace event communication
 */
angular.module('posApp').factory('loadCustomerInfo', () => {
  const loadCustomerInfo = function (pageRef) {
    loadCustomerInfo.pageRef = pageRef;
  };

  return loadCustomerInfo;
});
